(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advisor-concierge"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-concierge-form]').forEach(form => {
  const occasion = new URLSearchParams(window.location.search).get('occasion');
  const select = form.querySelector('[name="occasion"]');
  if (occasion && select && Array.from(select.options).some(option => option.value === occasion)) select.value = occasion;
});
document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-concierge-form]');
  if (!form) return;
  event.preventDefault();
  const phone = (form.dataset.phone || '').replace(/\D/g, '');
  if (!phone) return;
  const lines = [form.dataset.greeting];
  form.querySelectorAll('select, input').forEach((input) => {
    if (!input.value.trim()) return;
    const label = input.labels?.[0]?.textContent.trim() || input.name;
    lines.push(`${label}: ${input.value.trim()}`);
  });
  window.LoveMy?.track('advisor_whatsapp_click', { context: 'human_advice', fields_completed: lines.length - 1 });
  window.location.assign(`https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boutique-references"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lovemy-reviews')) {
  customElements.define('lovemy-reviews', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-lmb-rvpro-viewport]');
      this.track = this.querySelector('[data-lmb-rvpro-track]');
      this.originals = Array.from(this.track.children);
      if (this.originals.length < 6) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.pos = 3;
      this.travel = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.dragging = false;
      this.animating = false;
      const tails = this.originals.slice(-3).map(n => n.cloneNode(true));
      const heads = this.originals.slice(0, 3).map(n => n.cloneNode(true));
      this.clones = [...tails, ...heads];
      this.clones.forEach(n => { n.setAttribute('aria-hidden', 'true'); n.removeAttribute('data-shopify-editor-block'); });
      tails.forEach(n => this.track.insertBefore(n, this.originals[0]));
      heads.forEach(n => this.track.appendChild(n));
      this.slides = Array.from(this.track.children);
      this.classList.add('is-ready');
      this.querySelector('.lmb-rvPro__controls').hidden = false;
      this.toggle = this.querySelector('[data-review-toggle]');
      this.updateToggle = () => {
        this.toggle.hidden = this.motion.matches;
        this.toggle.textContent = this.paused ? this.dataset.paused : this.dataset.running;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
      };
      this.stop = () => { this.running = false; };
      this.start = () => {
        this.stop();
        if (this.paused || this.motion.matches || this.hovered || this.focused || this.dragging || !this.visible || document.hidden) return;
        this.running = true;
      };
      this.updateToggle();
      this.apply(false);
      this.track.addEventListener('transitionend', event => {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        this.animating = false;
        this.normalize();
      }, { signal });
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.start(); }, { signal });
      this.querySelector('[data-review-prev]').addEventListener('click', () => this.move(-1), { signal });
      this.querySelector('[data-review-next]').addEventListener('click', () => this.move(1), { signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1); }
      }, { signal });
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.stop(); } }, { signal });
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.start(); }, { signal });
      this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.start(); }, { signal });
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); this.start(); }, { signal });
      this.viewport.addEventListener('pointerdown', event => {
        if (event.button !== 0 || this.animating) return;
        this.dragging = true; this.dragDX = 0; this.dragStartX = event.clientX;
        this.stop(); this.viewport.classList.add('is-dragging');
        this.dragTX = new DOMMatrixReadOnly(getComputedStyle(this.track).transform).m41;
        this.track.style.transition = 'none';
        this.viewport.setPointerCapture(event.pointerId);
      }, { signal });
      this.viewport.addEventListener('pointermove', event => {
        if (!this.dragging) return;
        this.dragDX = event.clientX - this.dragStartX;
        const shift = Math.max(-this.step, Math.min(this.step, this.dragDX));
        this.track.style.transform = `translate3d(${this.dragTX + shift}px,0,0)`;
      }, { signal });
      const release = (event, cancelled) => {
        if (!this.dragging) return;
        this.dragging = false; this.viewport.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
        const threshold = Math.min(110, this.step * 0.18);
        if (!cancelled && Math.abs(this.dragDX) > threshold) this.pos += this.dragDX < 0 ? 1 : -1;
        this.travel = 0; this.apply(true); this.start();
      };
      this.viewport.addEventListener('pointerup', event => release(event, false), { signal });
      this.viewport.addEventListener('pointercancel', event => release(event, true), { signal });
      this.motion.addEventListener('change', () => { this.animating = false; this.normalize(); this.apply(false); this.updateToggle(); this.start(); }, { signal });
      document.addEventListener('visibilitychange', () => this.start(), { signal });
      this.resize = new ResizeObserver(() => { this.animating = false; this.normalize(); this.apply(false); });
      this.resize.observe(this.viewport);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.start(); });
      this.observer.observe(this);
      let previous = 0;
      const tick = time => {
        const elapsed = Math.min(time - (previous || time), 50);
        previous = time;
        if (this.running && !this.animating && !this.dragging && this.step > 0) {
          this.travel += elapsed * 0.026;
          if (this.travel >= this.step) {
            this.travel -= this.step;
            this.pos += 1;
            this.normalize();
            this.apply(false);
          }
          this.track.style.transition = 'none';
          this.track.style.transform = `translate3d(${this.baseX - this.travel}px,0,0)`;
          this.highlight();
        }
        this.animation = requestAnimationFrame(tick);
      };
      this.animation = requestAnimationFrame(tick);
    }
    apply(animate) {
      const count = innerWidth <= 640 ? 1 : innerWidth <= 1024 ? 2 : 3;
      this.visibleCount = count;
      const width = parseFloat(getComputedStyle(this.slides[this.pos]).width);
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.step = width + gap;
      const offset = Math.max(0, (this.track.clientWidth - (count * width + (count - 1) * gap)) / 2);
      this.baseX = offset - this.slides[this.pos].offsetLeft + this.slides[0].offsetLeft;
      const x = this.baseX - this.travel;
      this.animating = animate && !this.motion.matches;
      this.track.style.transition = this.animating ? 'transform 560ms cubic-bezier(.2,.8,.2,1)' : 'none';
      this.track.style.transform = `translate3d(${x}px,0,0)`;
      this.highlight();
      if (animate && this.motion.matches) this.normalize();
    }
    highlight() {
      const center = this.pos + Math.floor(this.visibleCount / 2) + (this.travel > this.step / 2 ? 1 : 0);
      if (center === this.center) return;
      this.center = center;
      this.slides.forEach((slide, index) => slide.classList.toggle('is-center', index === center));
    }
    normalize() {
      if (this.pos >= this.originals.length + 3) { this.pos -= this.originals.length; this.apply(false); }
      else if (this.pos < 3) { this.pos += this.originals.length; this.apply(false); }
    }
    move(direction) {
      if (this.animating || this.dragging) return;
      this.normalize(); this.travel = 0; this.pos += direction; this.apply(true);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.animation); this.stop?.(); this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      this.clones?.forEach(n => n.remove());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovemy-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lovemy-reviews')) {
  customElements.define('lovemy-reviews', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-lmb-rvpro-viewport]');
      this.track = this.querySelector('[data-lmb-rvpro-track]');
      this.originals = Array.from(this.track.children);
      if (this.originals.length < 6) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.pos = 3;
      this.travel = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.dragging = false;
      this.animating = false;
      const tails = this.originals.slice(-3).map(n => n.cloneNode(true));
      const heads = this.originals.slice(0, 3).map(n => n.cloneNode(true));
      this.clones = [...tails, ...heads];
      this.clones.forEach(n => { n.setAttribute('aria-hidden', 'true'); n.removeAttribute('data-shopify-editor-block'); });
      tails.forEach(n => this.track.insertBefore(n, this.originals[0]));
      heads.forEach(n => this.track.appendChild(n));
      this.slides = Array.from(this.track.children);
      this.classList.add('is-ready');
      this.querySelector('.lmb-rvPro__controls').hidden = false;
      this.toggle = this.querySelector('[data-review-toggle]');
      this.updateToggle = () => {
        this.toggle.hidden = this.motion.matches;
        this.toggle.textContent = this.paused ? this.dataset.paused : this.dataset.running;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
      };
      this.stop = () => { this.running = false; };
      this.start = () => {
        this.stop();
        if (this.paused || this.motion.matches || this.hovered || this.focused || this.dragging || !this.visible || document.hidden) return;
        this.running = true;
      };
      this.updateToggle();
      this.apply(false);
      this.track.addEventListener('transitionend', event => {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        this.animating = false;
        this.normalize();
      }, { signal });
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.start(); }, { signal });
      this.querySelector('[data-review-prev]').addEventListener('click', () => this.move(-1), { signal });
      this.querySelector('[data-review-next]').addEventListener('click', () => this.move(1), { signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1); }
      }, { signal });
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.stop(); } }, { signal });
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.start(); }, { signal });
      this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.start(); }, { signal });
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); this.start(); }, { signal });
      this.viewport.addEventListener('pointerdown', event => {
        if (event.button !== 0 || this.animating) return;
        this.dragging = true; this.dragDX = 0; this.dragStartX = event.clientX;
        this.stop(); this.viewport.classList.add('is-dragging');
        this.dragTX = new DOMMatrixReadOnly(getComputedStyle(this.track).transform).m41;
        this.track.style.transition = 'none';
        this.viewport.setPointerCapture(event.pointerId);
      }, { signal });
      this.viewport.addEventListener('pointermove', event => {
        if (!this.dragging) return;
        this.dragDX = event.clientX - this.dragStartX;
        const shift = Math.max(-this.step, Math.min(this.step, this.dragDX));
        this.track.style.transform = `translate3d(${this.dragTX + shift}px,0,0)`;
      }, { signal });
      const release = (event, cancelled) => {
        if (!this.dragging) return;
        this.dragging = false; this.viewport.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
        const threshold = Math.min(110, this.step * 0.18);
        if (!cancelled && Math.abs(this.dragDX) > threshold) this.pos += this.dragDX < 0 ? 1 : -1;
        this.travel = 0; this.apply(true); this.start();
      };
      this.viewport.addEventListener('pointerup', event => release(event, false), { signal });
      this.viewport.addEventListener('pointercancel', event => release(event, true), { signal });
      this.motion.addEventListener('change', () => { this.animating = false; this.normalize(); this.apply(false); this.updateToggle(); this.start(); }, { signal });
      document.addEventListener('visibilitychange', () => this.start(), { signal });
      this.resize = new ResizeObserver(() => { this.animating = false; this.normalize(); this.apply(false); });
      this.resize.observe(this.viewport);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.start(); });
      this.observer.observe(this);
      let previous = 0;
      const tick = time => {
        const elapsed = Math.min(time - (previous || time), 50);
        previous = time;
        if (this.running && !this.animating && !this.dragging && this.step > 0) {
          this.travel += elapsed * 0.026;
          if (this.travel >= this.step) {
            this.travel -= this.step;
            this.pos += 1;
            this.normalize();
            this.apply(false);
          }
          this.track.style.transition = 'none';
          this.track.style.transform = `translate3d(${this.baseX - this.travel}px,0,0)`;
          this.highlight();
        }
        this.animation = requestAnimationFrame(tick);
      };
      this.animation = requestAnimationFrame(tick);
    }
    apply(animate) {
      const count = innerWidth <= 640 ? 1 : innerWidth <= 1024 ? 2 : 3;
      this.visibleCount = count;
      const width = parseFloat(getComputedStyle(this.slides[this.pos]).width);
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.step = width + gap;
      const offset = Math.max(0, (this.track.clientWidth - (count * width + (count - 1) * gap)) / 2);
      this.baseX = offset - this.slides[this.pos].offsetLeft + this.slides[0].offsetLeft;
      const x = this.baseX - this.travel;
      this.animating = animate && !this.motion.matches;
      this.track.style.transition = this.animating ? 'transform 560ms cubic-bezier(.2,.8,.2,1)' : 'none';
      this.track.style.transform = `translate3d(${x}px,0,0)`;
      this.highlight();
      if (animate && this.motion.matches) this.normalize();
    }
    highlight() {
      const center = this.pos + Math.floor(this.visibleCount / 2) + (this.travel > this.step / 2 ? 1 : 0);
      if (center === this.center) return;
      this.center = center;
      this.slides.forEach((slide, index) => slide.classList.toggle('is-center', index === center));
    }
    normalize() {
      if (this.pos >= this.originals.length + 3) { this.pos -= this.originals.length; this.apply(false); }
      else if (this.pos < 3) { this.pos += this.originals.length; this.apply(false); }
    }
    move(direction) {
      if (this.animating || this.dragging) return;
      this.normalize(); this.travel = 0; this.pos += direction; this.apply(true);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.animation); this.stop?.(); this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      this.clones?.forEach(n => n.remove());
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
